import { Remove } from '@mui/icons-material';
import { Button, Divider, Grid } from '@mui/material';
import { Weekday } from '@thro-types/leihbar';

import { RecurringIntervalPicker } from './components/RecurringIntervalPicker';
import RecurringIntervalPickerSkeleton from './components/RecurringIntervalPickerSkeleton';

export interface RecurringIntervalValue {
  weekdays: Weekday[];
  start: number;
  end: number;
}
interface Props<T extends string> {
  fieldName: T;
  values: RecurringIntervalValue[];
  setFieldValue: (fieldName: T, value: RecurringIntervalValue[]) => void;
  isLoading?: boolean;
}

export const RecurringIntervalList = <T extends string>({
  fieldName,
  values,
  setFieldValue,
  isLoading
}: Props<T>) => {
  if (isLoading) {
    return <RecurringIntervalPickerSkeleton />;
  }
  return (
    <>
      {values.map((interval, index) => (
        <Grid container key={index}>
          <Grid item xs={11}>
            <RecurringIntervalPicker
              index={index}
              fieldName={fieldName}
              values={values}
              setFieldValue={setFieldValue}
            />
          </Grid>
          <Grid container item xs={1} justifyContent="flex-end">
            <Button
              variant="outlined"
              onClick={() => {
                const newIntervals = [...values];
                if (index > -1) {
                  newIntervals.splice(index, 1);
                }
                setFieldValue(fieldName, newIntervals);
              }}
              disabled={values.length - 1 === 0}
            >
              <Remove />
            </Button>
          </Grid>

          {index !== values.length - 1 && (
            <Grid item xs={12} paddingY={'1em'}>
              <Divider />
            </Grid>
          )}
        </Grid>
      ))}
    </>
  );
};
